function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}export var ApiFirebaseService = /*#__PURE__*/function () {ApiFirebaseService.$inject = ["$q", "firebase", "$firebaseObject", "gplansConf"];
  function ApiFirebaseService($q, firebase, $firebaseObject, gplansConf) {
    "ngInject";_classCallCheck(this, ApiFirebaseService);
    this.$q = $q;
    this.firebase = firebase;
    this.gplansConf = gplansConf;
    this.$firebaseObject = $firebaseObject;
  }_createClass(ApiFirebaseService, [{ key: "requestFirebaseObject", value: function requestFirebaseObject(

    ref) {var _this = this;
      return this.$q(function (rs, rj) {
        _this.$firebaseObject(ref).
        $loaded(rs, rj);
      });
    } }, { key: "getAppVersion", value: function getAppVersion(

    uid) {
      return this.requestFirebaseObject(
      this.firebase.database().ref().
      child("users").child(uid).child("appVersion"));

    } }, { key: "incrementAppVersion", value: function incrementAppVersion(

    uid) {var _this2 = this;
      return this.getAppVersion(uid).then(function (res) {
        var _appVersionFirebase = res;
        var _localVersion = parseInt(_appVersionFirebase.$value) || 0;
        _localVersion += 1;
        return _this2.setAppVersion(uid, _localVersion);
      });
    } }, { key: "setAppVersion", value: function setAppVersion(

    uid, appVersion) {var _this3 = this;
      return this.$q(function () {return _this3.firebase.database().ref().
        child("users").child(uid).child("appVersion").
        set(appVersion);});

    } }, { key: "getUserMeals", value: function getUserMeals(

    intercomId) {
      return this.requestFirebaseObject(
      this.firebase.database().ref().
      child('users').child(intercomId).
      child('user_meals'));

    } }, { key: "getUserMeal", value: function getUserMeal(

    intercomId, mealId) {
      return this.requestFirebaseObject(
      this.firebase.database().ref().
      child('users').child(intercomId).
      child('user_meals').
      child(mealId));

    } }, { key: "addUserMeal", value: function addUserMeal(

    intercomId, mealModel) {
      var mealCopy = normalizeMeal(mealModel);
      var newFireBaseMeal = {
        version_num: 1,
        meal_object: mealCopy };

      return this.firebase.database().ref().
      child('users').child(intercomId).
      child('user_meals').
      child(mealModel.id).
      set(newFireBaseMeal);
    } }, { key: "updateUserMeal", value: function updateUserMeal(

    intercomId, mealModel) {var _this4 = this;
      var mealCopy = normalizeMeal(mealModel);
      return this.getUserMeal(intercomId, mealCopy.id).
      then(function (_ref) {var version_num = _ref.version_num,meal_object = _ref.meal_object;
        return _this4.firebase.database().ref().
        child('users').child(intercomId).
        child('user_meals').
        child(mealModel.id).
        set({
          version_num: parseInt(version_num) + 1,
          meal_object: _objectSpread({},
          meal_object, {
            meal_items: mealCopy.meal_items || [],
            extra_items: mealCopy.extra_items || [],
            customMeal: mealCopy.customMeal || null,
            label: mealCopy.label || '' }) });


      });
    } }, { key: "updateOrCreateUserMeal", value: function updateOrCreateUserMeal(

    intercomId, mealModel) {var _this5 = this;
      return this.getUserMeal(intercomId, mealModel.id).
      then(function (_ref2) {var meal_object = _ref2.meal_object,version_num = _ref2.version_num;
        if (version_num) {
          return _this5.updateUserMeal(intercomId, mealModel);
        } else {
          return _this5.addUserMeal(intercomId, mealModel);
        }
      });
    } }, { key: "removeUserMeal", value: function removeUserMeal(

    intercomId, mealModel) {
      return this.firebase.database().ref().
      child("users").
      child(intercomId).
      child("user_meals").
      child(mealModel.id).
      remove();
    } }, { key: "removeAllUserMeals", value: function removeAllUserMeals(

    intercomId) {var _this6 = this;var week_number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (week_number) {
        return this.getUserMeals(intercomId).
        then(function (res) {
          Object.keys(res).forEach(function (mealId) {var _ref3 =
            res[mealId] || {},version_num = _ref3.version_num,meal_object = _ref3.meal_object;
            if (!meal_object) {
              return false;
            }
            if (week_number != meal_object.week_number) {
              _this6.removeUserMeal(intercomId, meal_object);
            }
          });
        });
      } else
      {
        return this.firebase.database().ref().
        child("users").
        child(intercomId).
        child("user_meals").
        remove();
      }
    } }, { key: "removeAndCreateUserMeal", value: function removeAndCreateUserMeal(

    intercomId, mealModel) {var _this7 = this;
      return this.removeUserMeal(intercomId, mealModel).then(function ()
      {_this7.addUserMeal(intercomId, mealModel);});

    } }, { key: "getUserMealTip", value: function getUserMealTip(

    intercomId) {
      return this.requestFirebaseObject(
      this.firebase.database().ref().
      child('users').child(intercomId).
      child('tip'));

    } }, { key: "removeUserMealTip", value: function removeUserMealTip(

    intercomId) {
      return this.firebase.database().ref().
      child("users").
      child(intercomId).
      child("tip").
      remove();
    } }, { key: "setGroceryList", value: function setGroceryList(

    intercomId, weekNumber, groceryList) {var _this8 = this;
      return this.$q(function (rs, rg) {
        rs(
        _this8.firebase.database().ref().
        child("users").child(intercomId).child("groceryLists").
        child(weekNumber).
        set(groceryList));

      });
    } }, { key: "getGroceryList", value: function getGroceryList(

    intercomId, weekNumber) {
      return this.requestFirebaseObject(
      this.firebase.database().ref().
      child("users").child(intercomId).
      child("groceryLists").
      child(weekNumber));

    } }]);return ApiFirebaseService;}();



function normalizeMeal(mealModel) {
  if (!mealModel) return mealModel;
  mealModel.extra_items = [];
  var mealItemToRemove = [];
  mealModel.calories = 0;
  mealModel.carbohydrates = 0;
  mealModel.fats = 0;
  mealModel.proteins = 0;
  mealModel.modal_calories = 0;
  mealModel.modal_carbohydrates = 0;
  mealModel.modal_fats = 0;
  mealModel.modal_proteins = 0;
  for (var i = 0; i < mealModel.meal_items.length; i++) {
    var meal_item = mealModel.meal_items[i];
    if (!meal_item.deleted) {
      mealModel.calories += Number(meal_item.calories);
      mealModel.carbohydrates += Number(meal_item.carbohydrates);
      mealModel.fats += Number(meal_item.fats);
      mealModel.proteins += Number(meal_item.proteins);
      mealModel.modal_calories += Number(meal_item.modal_calories);
      mealModel.modal_carbohydrates += Number(meal_item.modal_carbohydrates);
      mealModel.modal_fats += Number(meal_item.modal_fats);
      mealModel.modal_proteins += Number(meal_item.modal_proteins);
    }
    delete mealModel.meal_items[i].amount_model;
    if (meal_item.category == 'free' || meal_item.category == 'extra') {
      mealModel.extra_items.push(meal_item);
      mealItemToRemove.push(i);
    }
  }
  mealModel.calories = parseFloat(mealModel.calories.toFixed(2));
  mealModel.carbohydrates = parseFloat(mealModel.carbohydrates.toFixed(2));
  mealModel.fats = parseFloat(mealModel.fats.toFixed(2));
  mealModel.proteins = parseFloat(mealModel.proteins.toFixed(2));
  mealModel.modal_calories = parseFloat(mealModel.modal_calories.toFixed(2));
  mealModel.modal_carbohydrates = parseFloat(mealModel.modal_carbohydrates.toFixed(2));
  mealModel.modal_fats = parseFloat(mealModel.modal_fats.toFixed(2));
  mealModel.modal_proteins = parseFloat(mealModel.modal_proteins.toFixed(2));
  for (var _i = mealItemToRemove.length - 1; _i >= 0; _i--) {
    mealModel.meal_items.splice(mealItemToRemove[_i], 1);
  }
  delete mealModel.$pending;var _angular$fromJson =
  angular.fromJson(angular.toJson(mealModel.$copy())),tip = _angular$fromJson.tip,customMeal = _angular$fromJson.customMeal,mealCopy = _objectWithoutProperties(_angular$fromJson, ["tip", "customMeal"]);
  customMeal && delete customMeal.tip;
  if (mealCopy.recipe && !mealCopy.recipe.id) {
    mealCopy.recipe = null;
  }
  if (customMeal && customMeal.recipe && !customMeal.recipe.id) {
    customMeal.recipe = null;
  }
  return _objectSpread({},
  mealCopy, {
    customMeal: customMeal });

}